document.addEventListener("DOMContentLoaded", function () {
    var collapseElements = document.querySelectorAll(".collapse-persistent");

    for (var i = 0; i < collapseElements.length; i++) {
        var collapseElement = collapseElements[i];

        collapseElement.addEventListener("shown.bs.collapse", function () {
            localStorage.setItem("coll_" + this.id, true);
        });

        collapseElement.addEventListener("hidden.bs.collapse", function () {
            localStorage.removeItem("coll_" + this.id);
        });

        if (localStorage.getItem("coll_" + collapseElement.id) === "true") {
            collapseElement.classList.add("show");
        }
        else {
            collapseElement.classList.remove("show");
        }
    }
});